function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const LinkedInLogoIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "linkedin, logo",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 1C1.44772 1 1 1.44772 1 2V18C1 18.5523 1.44772 19 2 19H18C18.5523 19 19 18.5523 19 18V2C19 1.44772 18.5523 1 18 1H2ZM3.83853 7.92304H6.4693V16.2307H3.83853V7.92304ZM6.64229 5.1608C6.64229 5.98286 5.97588 6.64926 5.15383 6.64926C4.33177 6.64926 3.66537 5.98286 3.66537 5.1608C3.66537 4.33875 4.33177 3.67234 5.15383 3.67234C5.97588 3.67234 6.64229 4.33875 6.64229 5.1608ZM16.2309 11.1867C16.2309 8.68746 14.6156 7.7158 13.0109 7.7158C12.4855 7.68991 11.9624 7.80006 11.4937 8.03529C11.1379 8.2139 10.7653 8.62258 10.478 9.3333H10.4041V7.92364H7.92316V16.2373H10.5625V11.8155C10.5243 11.3626 10.6692 10.7773 10.9657 10.429C11.2622 10.0807 11.6864 9.99753 12.008 9.95529H12.1083C12.9476 9.95529 13.5704 10.4749 13.5704 11.7843V16.2373H16.2097L16.2309 11.1867Z",
  fill: "currentColor"
})));
export default LinkedInLogoIcon;